module.exports = __webpack_public_path__ + "static/media/nike-eor-watch-where-we-are-going.d8385231.jpg";